import {Component, forwardRef, Input, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DatasourcePickerModel } from '../datasource-picker.model';
import { MatDialog } from '@angular/material/dialog';
import { DatasourceDesignerModal, DESIGNER_MODE } from 'src/app/shared/datasource-components/datasource-designer/datasource-designer.modal';
import { Model_Datasource, AbwDatasourceColumn, AbwDatasourceFilter, AbwDatasourceParameter } from 'src/app/app.models';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { DatasourceFiltersDialogComponent } from '../datasource-filters-dialog/datasource-filters-dialog.component';
import { DatasourceParametersDialogComponent } from '../datasource-parameters-dialog/datasource-parameters-dialog.component';

@Component({
    selector: 'abw-datasource-picker-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatasourcePickerFormComponent),
        multi: true
      }
    ],
    templateUrl: './datasource-picker-form.component.html',
    styleUrls: ['./datasource-picker-form.component.scss']
})
export class DatasourcePickerFormComponent extends AbstractWorkflowFormComponent<DatasourcePickerModel, { NUM_DATASOURCE: string, TITRE: string, DS_COLUMNS: AbwDatasourceColumn[], DS_FILTERS: AbwDatasourceFilter[], DS_PARAMETERS?: AbwDatasourceParameter[], IS_CACHED?: boolean }> {
	@Input() model: DatasourcePickerModel;
    @Input() value: { NUM_DATASOURCE: string, TITRE: string, DS_COLUMNS: AbwDatasourceColumn[], DS_FILTERS: AbwDatasourceFilter[], DS_PARAMETERS?: AbwDatasourceParameter[], IS_CACHED?: boolean };

    constructor(
        private _dialog: MatDialog,
        _workflowComponentsService: WorkflowComponentsService,
        _cdf: ChangeDetectorRef,
        _injector: Injector
	) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async openDatasourcePickerDialog() {
        const dialogRef = this._dialog.open(DatasourceDesignerModal, {
            data: {
                designerMode: DESIGNER_MODE.SELECTION_MODE,
                datasource: this.value
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((_result?: Model_Datasource) => {
            if (!_result) { return; } 
            this.onValueChanged({ NUM_DATASOURCE: _result.NUM_DATASOURCE, TITRE: _result.TITRE, DS_COLUMNS: _result.DS_PARAMS.DS_COLUMNS, DS_FILTERS: [], DS_PARAMETERS: _result.DS_PARAMS.DS_PARAMETERS, IS_CACHED: this.value?.IS_CACHED });
        });
    }

    async openDatasourceFiltersDialog() {
        const dialogRef = this._dialog.open(DatasourceFiltersDialogComponent, {
            data: {
                datasource: this.value,
                workflowComponents: this.model.workflowComponents,
                gridComponents: this.model.gridComponents,
                variables: this.model.variablesEnvironnement
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result || !_result.DS_FILTERS) { return; }
            this.value.DS_FILTERS = _result.DS_FILTERS;
            this.onValueChanged(JSON.parse(JSON.stringify(this.value)));
        });
    }

    async openDatasourceParametersDialog() {
        const dialogRef = this._dialog.open(DatasourceParametersDialogComponent, {
            data: {
                datasource: this.value,
                workflowComponents: this.model.workflowComponents,
                gridComponents: this.model.gridComponents,
                variables: this.model.variablesEnvironnement
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result) { return; }
            this.value.DS_PARAMETERS = _result;
            this.onValueChanged(JSON.parse(JSON.stringify(this.value)));
        });
    }

    countParametersFilled() {
        if (!this.value?.DS_PARAMETERS) { return 0; }
        return this.value?.DS_PARAMETERS.filter(p => p.DEFAULT_VALUE !== undefined && p.DEFAULT_VALUE !== null).length;
    }

    toggleCache(_event) {
        this.value.IS_CACHED = _event.detail.checked;
        this.onValueChanged(this.value);
    }
}